export default {
  namespaced: true,

  state: () => ({
    downloading: false,
    isMinimized: false,
    percent: 0,
    cancelRequested: false,
  }),

  mutations: {
    START(state) {
      state.downloading = true;
      state.isMinimized = false;
      state.percent = 0;
      state.cancelRequested = false;
    },

    UPDATE_PERCENT(state, value) {
      state.percent = value;
    },

    MINIMIZE(state) {
      state.isMinimized = true;
    },

    RESTORE(state) {
      state.isMinimized = false;
    },

    REQUEST_CANCEL(state) {
      state.cancelRequested = true;
    },

    FINISH(state) {
      state.downloading = false;
      state.isMinimized = false;
      state.percent = 0;
      state.cancelRequested = false;
    },

    REQUEST_CANCEL_INTERNAL(state) {
      state._internalAbort = Date.now();
    },
  },
};
